module.exports = __webpack_public_path__ + "static/media/021_g2-2Join with errors and onfocus.c0f5a6fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/gigable/021_g2-2Join with errors and onfocus.png
// module id = 444
// module chunks = 0